//===----------------------------------------------------------------------===//
//
//  Copyright 2024-2026 Trovares Inc. dba Rocketgraph.  All rights reserved.
//
//===----------------------------------------------------------------------===//

import { Box } from '@mui/material';
import { SxProps, Theme, useTheme } from '@mui/material/styles';

export const HomeLogo = () => {
  const theme = useTheme(); // Get the current theme

  return (
    <h1
      className="clear"
      style={{
        margin: 0,
        padding: 0,
      }}
    >
      <Box
        component="img"
        src={theme.logo.home}
        alt="Rocketgraph Logo"
        sx={{
          width: '500px',
          height: 'auto',
          filter: 'drop-shadow(0px 0px 5px rgba(0, 0, 0, 0.6))',
        }}
      />
    </h1>
  );
};

interface MenuLogoProps {
  sx?: SxProps<Theme>;
}

export const MenuLogo = ({ sx = {} }: MenuLogoProps) => {
  const theme = useTheme(); // Get the current theme

  return (
    // Every page needs a h1. Make the logo image the h1.
    <h1
      style={{
        margin: 0,
        padding: 0,
      }}
    >
      <Box
        component="img"
        src={theme.logo.menu}
        alt="Rocketgraph Mission Control Logo"
        sx={[
          {
            display: 'block',
            width: '225px',
            height: 'auto',
            padding: '2px',
          },
          ...(Array.isArray(sx) ? sx : [sx])
        ]}
      />
    </h1>
  );
};

export const IconLogo = () => {
  const theme = useTheme(); // Get the current theme
  return (
    <h1
      className="clear"
      style={{
        margin: 0,
        padding: 0,
      }}
    >
      <Box
        component="img"
        src={theme.logo.icon}
        alt="Rocketgraph Logo"
        sx={{
          width: '100px',
          height: 'auto',
        }}
      />
    </h1>
  );
};
